var BASWebServices;
(function (BASWebServices) {
    var RestartController = (function () {
        function RestartController($scope, $state, ngDialog, wsData) {
            this.$scope = $scope;
            this.$state = $state;
            this.ngDialog = ngDialog;
            this.wsData = wsData;
            this.$scope.rc = this;
        }
        RestartController.prototype.restartNow = function () {
            this.$state.transitionTo(this.$state.current, {}, {
                inherit: false,
                notify: true
            });
        };
        RestartController.prototype.resetData = function () {
            this.wsData.clearSets();
        };
        return RestartController;
    }());
    BASWebServices.RestartController = RestartController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=RestartController.js.map